import Vehicle_Minimal from './Vehicle_Minimal'
import Vehicle_Documents from './Vehicle_Documents'
import Vehicle_Full from './Vehicle_Full'

export default {
    Vehicle_Minimal,
    Vehicle_Documents,
    Vehicle_Full,
}
